import React from "react";
import backimg from "../assets/Bechtrack-images/backround.webp";
import { Link } from "react-router-dom";
import image1 from "../assets/Bechtrack-images/Frame-12.webp";
import Frame1 from "../assets/Bechtrack-images/Frame1.svg";
import Frame2 from "../assets/Bechtrack-images/Frame2.svg";
import Frame3 from "../assets/Bechtrack-images/Frame3.svg";
import Frame4 from "../assets/Bechtrack-images/Frame4.svg";
import Line1 from "../assets/Bechtrack-images/line1.png";
import Frame5 from "../assets/Bechtrack-images/Group70.png";
import Backimg2 from "../assets/Bechtrack-images/benchtrack2.webp";
import Frame6 from "../assets/Bechtrack-images/Group11.webp";
import Frame7 from "../assets/Bechtrack-images/back1.png";
import Accordion from "../pages/Accordion";
import AOS from "aos";
import "aos/dist/aos.css";

const Benchtrack = () => {
  AOS.init({
    disable: function () {
      return window.innerWidth < 768; 
    },

    
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,

   
    offset: 80, 
    delay: 50, 
    duration:1000, 
    easing: "ease-out", 
    once: false, 
    mirror: false, 
    anchorPlacement: "top-bottom",
  });


  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 relative"
        style={{ backgroundImage: `url(${backimg})` }}
      >
        <div
          className="flex flex-col items-center justify-center gap-4 pt-20"
          data-aos="fade-down"
        >
          <h1 className="text-white text-2xl sm:text-4xl md:text-5xl font-semibold text-center">
            Unlock Your Career Potential
          </h1>
          <p className="text-white text-sm sm:text-base text-center">
            Job Consulting Services That Deliver Results
          </p>
        </div>
        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
          data-aos="fade-down"
        >
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to="/contact-us"
            className="bg-none border border-white text-white text-sm py-2 px-4 rounded-full hover:bg-white hover:text-[#C32A7C] transition-colors duration-300"
          >
            Contact Us
          </Link>
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to="#"
            className="text-white text-sm bg-[#C32A7C] py-2 px-4 rounded-full hover:text-[#C32A7C] hover:bg-white transition-colors duration-300"
          >
            Explore Now
          </Link>
        </div>
        <div
          className="flex items-center justify-center w-full"
          data-aos="fade-down"
        >
          <img
            data-aos="zoom-in"
            data-aos-delay="300"
            className="w-full max-w-[953px] mt-10"
            src={image1}
            alt="back"
            style={{ maxWidth: "953px", height: "auto" }}
          />
        </div>
      </div>

      {/* Section 2 */}
      <div className="bg-white mt-5 px-4 md:px-8 lg:px-16 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center">
          {[
            { value: "5M", description: "4 million daily active users" },
            { value: "24k", description: "Over 12k open job positions" },
            { value: "15M", description: "Over 20 million stories shared" },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-gray-100 w-full p-6 rounded-lg flex flex-col items-center text-center transition-all duration-300 hover:border hover:tracking-wider hover:shadow-lg"
            >
              <h2 className="text-black text-2xl font-semibold">
                {item.value}
              </h2>
              <p className="text-black text-sm mt-2">{item.description}</p>
              <img className="w-12 max-h-5 mt-3" src={Line1} alt="" />
            </div>
          ))}
        </div>
      </div>

      {/* Section 3 */}
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="relative max-w-screen-xl mx-auto">
          <h2
            className="text-black font-semibold text-2xl md:text-3xl lg:text-3xl text-center mb-8 lg:mb-12"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Benchtrack Perform
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-4">
            {[
              {
                img: Frame1,
                desc: "We understand the challenges of the modern job market.",
              },
              {
                img: Frame2,
                desc: "Our mission is to empower individuals to achieve their career aspirations.",
              },
              {
                img: Frame3,
                desc: "We provide personalized career coaching, resume and cover letter writing, job search strategy development, interview preparation, and more.",
              },
              {
                img: Frame4,
                desc: "Our team of experienced career consultants are passionate about helping you succeed.",
              },
            ].map((service, index) => (
              <div
                data-aos="zoom-in-down"
                key={index}
                className="sec3 flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105 hover:shadow-xl mx-auto w-full max-w-[500px] mt-10"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col md:px-6 md:py-8 items-center rounded border bg-[#FFFFFF] w-full transition-all duration-300">
                  <img
                    className="md:-mt-[75px] lg:-mt-[75px] -mt-[40px] transform transition-transform duration-300"
                    src={service.img}
                    alt="Service"
                  />
                  <p className="text-sm text-black mt-5 md:mb-0  mb-7 lg:mt-6 w-full px-2 md:px-0 lg:w-[400px] min-h-[60px] flex items-center justify-center">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 4 */}
      <div className="bg-white mt-5 px-4 md:px-8 lg:px-16 py-10">
        <div className="flex flex-wrap lg:flex-nowrap justify-around items-center gap-6">
          <div className="flex flex-col gap-6 max-w-[500px]">
            <div className="flex flex-col items-start gap-4">
              <img
                className="w-20 max-h-10 ml-2"
                src={Line1}
                alt="Line"
                data-aos="fade-up"
              />
              <h1
                className="text-[#1A5298] text-4xl font-semibold mt-4"
                data-aos="fade-up"
              >
                Job Board
              </h1>
            </div>
            <div className="flex flex-col gap-4" data-aos="fade-up">
              <div className="flex-wrap items-start gap-2">
                <span className="text-black md:text-xl text:base font-semibold">
                  Find Job Opportunities:
                </span>
                <span className="text-[#7A7979] md:text-xl text-base w-[465px] pl-2">
                  Search for jobs based on keywords, location, industry, and
                  other criteria.
                </span>
              </div>
              <div className="flex-wrap items-start gap-2 mt-3">
                <span className="text-black md:text-xl text-base font-semibold">
                  Apply Online:
                </span>
                <span className="text-[#7A7979] md:text-xl text-base pl-2">
                  Easily submit applications and resumes directly through the
                  platform.
                </span>
              </div>
              <div className="flex-wrap items-start gap-2 mt-3">
                <span className="text-black md:text-xl text-base font-semibold">
                  Career Resources:
                </span>
                <span className="text-[#7A7979] md:text-xl text-base pl-2">
                  Access career advice, salary information, and industry news.
                </span>
              </div>
            </div>
            <Link
              data-aos="zoom-in"
              data-aos-delay="300"
              to=""
              className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap border border-[#C32A7C]"
            >
              Learn More
            </Link>
          </div>
          <div
            className="flex justify-center lg:justify-end w-full lg:w-auto"
            data-aos="fade-up"
          >
            <img
              className="w-full max-w-[350px] sm:max-w-[250px] md:max-w-[350px] lg:max-w-[600px]"
              src={Frame5}
              alt="Job Board"
            />
          </div>
        </div>
      </div>

      {/* Section 5 */}
      <div
        className="bg-cover bg-center min-h-[421px] bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-4 sm:px-6 md:px-8 lg:px-16 relative"
        style={{ backgroundImage: `url(${Backimg2})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
        <div className="relative z-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-8 lg:px-16 py-10">
          <h1
            className="text-white font-semibold text-xl sm:text-3xl md:text-4xl lg:text-4xl mt-10 sm:mt-20 text-center mx-auto"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            Add your job board profile for free in our directory
          </h1>
          <p
            className="text-white text-sm sm:text-base md:text-lg mt-4 sm:mt-6 max-w-full sm:max-w-[500px] md:max-w-[600px] lg:max-w-[700px] text-center mx-auto"
            data-aos="zoom-in"
            data-aos-delay="350"
          >
            Are you a job board? Do you want to attract new users and customers?
            Get better visibility by subscribing for free to our job site
            directory. Join your competitors and be side by side in our
            comparison tool.
          </p>
        </div>
      </div>

      {/* Section 6 */}
      <div className="bg-white mt-5 px-4 md:px-8 lg:px-16 py-10">
        <div className="flex flex-wrap lg:flex-nowrap justify-around items-center gap-6">
          <div className="flex flex-col gap-6 max-w-[500px] w-full">
            <div className="flex flex-col items-start gap-4">
              <img
                className="w-20 max-h-10"
                src={Line1}
                alt="Line"
                data-aos="fade-up"
              />
              <h1
                className="text-[#1A5298] text-2xl sm:text-3xl md:text-4xl font-semibold mt-4 lg:w-[550px]"
                data-aos="fade-up"
              >
                Millions of Jobs. Find the one that suits you.
              </h1>
              <p
                className="mt-5 text-black text-sm sm:text-base md:text-lg max-w-full sm:max-w-[514px]"
                data-aos="fade-up"
              >
                Search all the open positions on the web. Get your own
                personalized salary estimate. Read reviews on over 600,000
                companies worldwide.
              </p>
            </div>
            <Link
              data-aos="zoom-in"
              data-aos-delay="300"
              to=""
              className=" mt-5 w-full sm:max-w-[300px] bg-[#C32A7C] px-4 py-2 sm:px-5 sm:py-2.5 md:px-6 md:py-3 lg:px-8 lg:py-3 rounded-lg text-white font-semibold hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-500 ease-in-out text-sm sm:text-base md:text-lg text-center whitespace-nowrap border border-[#C32A7C]"
            >
              Search Millions of Jobs
            </Link>
          </div>
          <div className="flex justify-center lg:justify-end w-full lg:w-auto">
            <div className="group relative" data-aos="fade-up">
              <img
                className="w-full max-w-[150px] sm:max-w-[250px] md:max-w-[350px] lg:max-w-[399px] transform transition-transform duration-300 group-hover:scale-105"
                src={Frame6}
                alt="Job Board"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 7 */}
      <div className="bg-[#F6F6F6] mt-5 px-4 md:px-8 lg:px-16 py-10">
        <div className="flex flex-col lg:flex-row lg:justify-center items-center lg:items-start gap-8 lg:gap-10">
          <div className="w-full lg:w-auto" data-aos="fade-up">
            <img
              className="w-full max-w-[350px] h-auto mx-auto lg:mx-0"
              src={Frame7}
              alt="Talented People"
            />
          </div>
          <div className="w-full lg:w-auto">
            <img
              className="w-20 max-h-10"
              src={Line1}
              alt="Line"
              data-aos="fade-up"
            />
            <h2
              className="text-[#1A5298] text-xl sm:text-2xl md:text-3xl font-semibold mt-5 max-w-full lg:max-w-[513px]"
              data-aos="fade-up"
            >
              Get World 50,000+ Talented People In One Place
            </h2>
            <p
              className="text-black text-sm sm:text-base md:text-lg mt-5 max-w-full lg:max-w-[605px]"
              data-aos="fade-up"
            >
              To start searching for jobs, you can attend job fairs online or in
              person, use job boards and career websites, or reach out directly
              to recruiters in a targeted company to broaden your network.
            </p>
          </div>
        </div>
      </div>

      {/* Section 8 */}
      <div className="bg-white py-10 px-4 sm:px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <div className="bg-[#F0FAFF] lg:row-span-2 col-span-1 rounded-3xl p-5 lg:p-6 flex flex-col items-center text-center gap-4 w-full h-auto">
            <h1
              className="text-black text-lg lg:text-xl font-semibold"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Unlock Your Potential One Click
            </h1>
            <div
              className="flex items-center justify-center w-full"
              data-aos="fade-up"
              data-aos-delay="350"
            >
              <img
                src={require("../assets/Bechtrack-images/screen-mousepointer.png")}
                alt="icon"
                className="w-full max-w-xs mx-auto rounded-lg"
              />
            </div>
          </div>

          <div
            className="bg-[#F6F6F6] lg:col-span-2 rounded-3xl flex p-5 lg:p-6 items-center gap-4 w-full"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="flex-1">
              <h1 className="text-black font-semibold text-lg lg:text-xl">
                Search for a job can be a daunting task
              </h1>
              <p className="text-[#333333] mt-2 text-sm lg:text-base">
                We have created a powerful platform that connects talented
                individuals like you with exciting career opportunities.
              </p>
            </div>
            <img
              src={require("../assets/Bechtrack-images/benchtracksec8.png")}
              alt="search job"
              className="w-16 sm:w-20 lg:w-32 hidden sm:block"
            />
          </div>

          <div
            className="bg-[#FFEEF7] lg:col-span-2 rounded-3xl p-5 lg:p-6 flex flex-col w-full"
            data-aos="fade-up"
            data-aos-delay="350"
          >
            <h1 className="text-black font-semibold text-lg lg:text-xl">
              Discover Perfect Job Hassle-Free
            </h1>
            <div className="bg-white rounded-xl p-4 mt-4 flex items-center gap-4 w-full max-w-xs sm:max-w-sm shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src={require("../assets/Bechtrack-images/User2.png")}
                alt="User"
                className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover flex-shrink-0"
              />
              <div>
                <h3 className="text-black font-semibold text-sm lg:text-base">
                  Cotex Ber
                </h3>
                <p className="text-[#ABABAB] text-xs lg:text-sm">
                  Senior Animator
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 9 */}
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="relative max-w-screen-xl mx-auto">
          <h2
            className="text-black font-semibold text-2xl md:text-3xl lg:text-3xl text-center mb-8 lg:mb-12"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Popular services
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-4">
            {[
              {
                img: Frame1,
                title: "Correct My Profile",
                desc: "To start your Jobseeker journey with us, submit your resume and cover letter for review.",
              },
              {
                img: Frame2,
                title: "Job Search Strategy",
                desc: "Our team of experienced career consultants are passionate about helping you succeed.",
              },
              {
                img: Frame3,
                title: "Interview Preparation",
                desc: "We provide personalized career coaching, resume and cover letter writing, job search strategy development, interview preparation, and more.",
              },
              {
                img: Frame4,
                title: "Career Coaching",
                desc: "Our mission is to empower individuals to achieve their career aspirations.",
              },
            ].map((service, index) => (
              <div
                data-aos="zoom-in-down"
                key={index}
                className="sec3 flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105 hover:shadow-xl mx-auto w-full max-w-[500px] mt-10"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col md:px-6 md:py-8 items-center rounded border bg-[#FFFFFF] w-full transition-all duration-300">
                  <img
                    className="md:-mt-[75px] lg:-mt-[75px] -mt-[40px] transform transition-transform duration-300"
                    src={service.img}
                    alt="Service"
                  />
                  <h3 className="sec3title text-black text-xl font-semibold mt-5">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black md:mb-0  mb-7 mt-5 lg:mt-6 w-full px-2 md:px-0 lg:w-[400px] min-h-[60px] flex items-center justify-center">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* Section 11 */}
      <Accordion />
    </>
  );
};

export default Benchtrack;
